function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  fillRule: "evenodd",
  d: "M8.01 12.385c.167.17.396.267.634.267.24 0 .468-.096.636-.267l3.546-3.62c.343-.351.337-.914-.013-1.257-.351-.344-.914-.338-1.257.013L9.533 9.585V1.89c0-.491-.398-.889-.889-.889-.49 0-.888.398-.888.889v7.696L5.734 7.521c-.344-.351-.906-.357-1.257-.013-.351.343-.357.906-.013 1.257l3.545 3.62zm8.279-1.115v4.841c0 .491-.398.889-.889.889H1.889C1.398 17 1 16.602 1 16.111v-4.84c0-.491.398-.89.889-.89.49 0 .889.399.889.89v3.951H14.51V11.27c0-.49.398-.888.889-.888.49 0 .889.398.889.888z"
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6eb200a7.svg";
export { ForwardRef as ReactComponent };